import aws_cloud from "./images/awscld.jpg";
import mta from "./images/mtazure.png";
import redhat from "./images/redhat.png";
import aws_solution from "./images/awsarch.png";
import Button from "@material-ui/core/Button";
import Card from "react-bootstrap/Card";
import React from 'react';

const Achievements = () => {
    const items = [
        {
            img: aws_solution,
            cardTitle: "AWS Certified Solution Architect Associate",
            cardText: "Issued on: <br/> October 27, 2023",
            btnText: "See Credential",
            btnUrl: "https://www.credly.com/badges/b210242c-3072-4e4a-8607-5d0929a4bc6a/linked_in_profile",

        },
        {
            img: mta,
            cardTitle: "Microsoft Certified: Azure Administrator Associate",
            cardText: "Issued on: <br/> September 20, 2023",
            btnText: "See Credential",
            btnUrl: "https://learn.microsoft.com/api/credentials/share/en-us/HinaHirpara-9718/B0B5F38D6F048B70?sharingId",
        },
        {
            img: aws_cloud,
            cardTitle: "AWS Certified Cloud practitioner",
            cardText: "Issued on: <br/> February 18, 2021",
            
        },
        {
            img: redhat,
            cardTitle: "Red Hat Certified Engineer",
            cardText: "Issued on: <br/> March 2021",
           
        },

    ];
    return (
        <section id="achievements" class="about background-alt">
            <div class="container" data-aos="fade-up">
                <div class="section-title">
                    <h2>Achievements</h2>
                </div>
                <div class="row">
                    {items.map((data, i) => (
                        <div
                            class="col-sm-3 d-flex justify-content-center"
                            key={i}
                        >
                            {/* <div class="card shadow-large h-100 achievement-card" style={{maxWidth: "270px", background: "#343a40", padding: "20px"}}>
                    <img class="card-img-top responsive" src={data.img} height="50%" width="30%"/>
                  <div class="card-body">
                    <h5 class="card-title" style={{color: "rgba(255, 255, 255, 0.8)", fontSize: "16px"}}>{data.cardTitle}</h5>
                    <p class="card-text" style={{color: "#74808a"}}>{data.cardText}</p>
                    <a href="https://www.credential.net/bef2570d-7d63-4f07-be28-57ec4da87373" target="_blank" class="btn btn-primary">See Credential</a>
                  </div>
                </div> */}
                            <Card
                                style={{
                                    width: "16rem",
                                    background: "#343a40",
                                    padding: "20px",
                                }}
                                className="text-center"
                            >
                                <Card.Img variant="top" src={data.img} />
                                <Card.Body>
                                    <Card.Title
                                        style={{
                                            color: "rgba(255, 255, 255, 0.7)",
                                            fontSize: "18px",
                                        }}
                                    >
                                        {data.cardTitle}
                                    </Card.Title>
                                    <br></br>
                                    <Card.Text style={{ color: "#74808a" }}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: data.cardText,
                                            }}
                                        ></div>
                                    </Card.Text>
                                    {data.btnText && (
                                        <Button
                                            variant="contained"
                                            color="default"
                                            target="_blank"
                                            href={data.btnUrl}
                                        >
                                            {data.btnText}
                                        </Button>
                                    )}
                                </Card.Body>
                            </Card>
                            <br></br>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Achievements;
